import type { DrawerProps } from 'antd'
import { Drawer } from 'antd'
import React, { ReactNode } from 'react'

export interface GlobalDrawerProps extends Partial<DrawerProps> {
    open: boolean
    onClose: () => void
    children: ReactNode
}

export const DrawerComponent: React.FC<GlobalDrawerProps> = ({ open, onClose, children, ...props }) => {
    return (
        <Drawer
            open={open}
            onClose={onClose}
            width={520}
            placement='right'
            styles={{
                body: {
                    background: '#ffffff',
                    padding: 0
                },
                wrapper: {
                    boxShadow: '-2px 0 8px rgba(0,0,0,0.06)'
                }
            }}
            style={{
                borderLeft: '1px solid #e5e7eb'
            }}
            {...props}
        >
            {children}
        </Drawer>
    )
}

export default DrawerComponent
